import { useEffect, useRef } from 'react';
import { notification } from 'antd';
import { CheckCircleOutlined, WarningOutlined } from '@ant-design/icons';
import { useServiceStatus } from '@/contexts/service-status';
import type { ServiceName, ServiceStatus } from '@/contexts/service-status/types';

const SERVICE_NAMES: Record<ServiceName, string> = {
  auth: 'Autenticacao',
  user: 'Usuarios',
  registration: 'Cadastros',
  inspection: 'Inspecoes',
  checklist: 'Checklists',
  notification: 'Notificacoes',
  scraper: 'Busca de Imoveis',
};

export function ServiceStatusToast(): null {
  const { status } = useServiceStatus();
  const previousStatusRef = useRef<Record<ServiceName, ServiceStatus>>({ ...status });
  const isFirstRenderRef = useRef(true);

  useEffect(() => {
    // Ignorar a primeira renderizacao para nao mostrar toasts no carregamento inicial
    if (isFirstRenderRef.current) {
      isFirstRenderRef.current = false;
      previousStatusRef.current = { ...status };
      return;
    }

    const services = Object.keys(status) as ServiceName[];

    services.forEach(service => {
      const newStatus = status[service];
      const oldStatus = previousStatusRef.current[service];

      // Ignorar auth (SystemOffline trata) e checking
      if (service === 'auth' || oldStatus === 'checking' || newStatus === 'checking') return;

      if (newStatus === 'offline' && oldStatus === 'online') {
        notification.warning({
          message: 'Servico indisponivel',
          description: `${SERVICE_NAMES[service]} esta temporariamente offline. Algumas funcionalidades podem estar limitadas.`,
          icon: <WarningOutlined style={{ color: '#faad14' }} />,
          duration: 5,
          key: `service-status-${service}`,
        });
      } else if (newStatus === 'online' && oldStatus === 'offline') {
        notification.success({
          message: 'Servico restaurado',
          description: `${SERVICE_NAMES[service]} esta online novamente.`,
          icon: <CheckCircleOutlined style={{ color: '#52c41a' }} />,
          duration: 3,
          key: `service-status-${service}`,
        });
      }
    });

    previousStatusRef.current = { ...status };
  }, [status]);

  return null;
}
